import React, { useState } from 'react';
import { 
  TextField, 
  InputAdornment,
  FormHelperText 
} from '@mui/material';
import { Phone, CheckCircle, Error } from '@mui/icons-material';

const PhoneNumberField = ({ value, onChange, onBlur, error, helperText, lang, ...props }) => {
  const [internalError, setInternalError] = useState('');
  const [touched, setTouched] = useState(false);

  const validatePhone = (phone) => {
    const regex = /^(\+60|0)?1[0-9]{9}$/;
    if (!phone) return lang === 'ar' ? 'رقم الهاتف مطلوب' : 'Phone number is required';
    if (!regex.test(phone.replace(/\s/g, ''))) {
      return lang === 'ar' ? 'الرجاء إدخال رقم هاتف ماليزي صالح' : 'Please register a valid Malaysian phone number';
    }
    return '';
  };

  const handleChange = (e) => {
    const input = e.target.value;
    // Allow only numbers and + sign
    const cleanedValue = input.replace(/[^\d+]/g, '');
    onChange(cleanedValue);
    
    if (touched) {
      const validationError = validatePhone(cleanedValue);
      setInternalError(validationError);
    }
  };

  const handleBlurInternal = (e) => {
    setTouched(true);
    const validationError = validatePhone(value);
    setInternalError(validationError);
    if (onBlur) onBlur(e);
  };

  const displayError = error || internalError;
  const isValid = touched && !displayError && value;

  return (
    <>
      <TextField
        {...props}
        placeholder='EX +60 123456789'
        value={value}
        onChange={handleChange}
        onBlur={handleBlurInternal}
        error={!!displayError}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Phone color={isValid ? 'success' : 'disabled'} />
            </InputAdornment>
          ),
          endAdornment: isValid && (
            <InputAdornment position="end">
              <CheckCircle color="success" />
            </InputAdornment>
          ),
        }}
      />
      {displayError && (
        <FormHelperText error>{displayError}</FormHelperText>
      )}
      {helperText && !displayError && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </>
  );
};

export default PhoneNumberField;